import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import { FormGroup } from "../../../common-components";
import { clearRegistrationBackendError } from "../../data/actions";

const FirstNameField = (props) => {
  const dispatch = useDispatch();

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    dispatch(clearRegistrationBackendError("first_name"));
  };

  const handleOnFocus = () => {
    handleErrorChange("first_name", "");
    dispatch(clearRegistrationBackendError("first_name"));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

FirstNameField.defaultProps = {
  errorMessage: "",
};

FirstNameField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default FirstNameField;
